var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"old-app"},[_c('system-bar-space'),_c('div',{staticClass:"wrapper"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }